import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import Highlighter from 'react-highlight-words'
import AutocompleteItem from 'components/AutocompleteItem'
import styles from './styles.scss'
import {
  ITEM_MONIKER_NOT_FOUND,
  ITEM_MONIKER_TOO_MANY,
  ITEM_MONIKER_TOO_SHORT,
  TOO_MANY_WARNING,
  TOO_SHORT_WARNING,
} from './constants'

class AutocompleteResult extends PureComponent {
  render() {
    const {
      item,
      search,
      isHighlighted,
      onMouseEnter,
      onClick,
    } = this.props

    let children
    let extraProps = {
      isHighlighted,
      onMouseEnter,
      onClick,
      className: styles.result,
    }

    if (item.Moniker === ITEM_MONIKER_NOT_FOUND) {
      children = (
        <span>Address not found? <span className={styles.link}>Click here</span></span>
      )
    } else if (item.Moniker === ITEM_MONIKER_TOO_SHORT) {
      children = (
        <span>{TOO_SHORT_WARNING}</span>
      )
      extraProps = {
        className: styles.noSearch,
      }
    } else if (item.Moniker === ITEM_MONIKER_TOO_MANY) {
      children = (
        <span className={styles.warning}>
          <div>
            {TOO_MANY_WARNING}&nbsp;
            <span className={styles.link}>
              Manually enter your address
            </span>
          </div>
        </span>
      )
    } else {
      const address = ((item || {}).Picklist || '').match(/[^,]+,?/g)
      const postcode = (item || {}).Postcode || ''

      children = address.map(part => (
        <Highlighter
          key={part}
          autoEscape
          highlightClassName={styles.highlight}
          searchWords={search.split(' ')}
          textToHighlight={part}
        />
      ))
      children.push(<span key={ITEM_MONIKER_NOT_FOUND}> {postcode}</span>)
    }

    return (
      <AutocompleteItem
        {...extraProps}
      >
        {children}
      </AutocompleteItem>
    )
  }
}

AutocompleteResult.defaultProps = {
  item: {
    Picklist: '',
    Moniker: '',
    Postcode: '',
  },
  search: '',
  isHighlighted: false,
  onMouseEnter: f => f,
  onClick: f => f,
}

AutocompleteResult.propTypes = {
  item: PropTypes.shape({
    Picklist: PropTypes.string,
    Moniker: PropTypes.string,
    Postcode: PropTypes.string,
  }),
  search: PropTypes.string,
  isHighlighted: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onClick: PropTypes.func,
}

export default AutocompleteResult



// WEBPACK FOOTER //
// ./components/AutocompleteResult/index.jsx